import { render, staticRenderFns } from "./CloseOutlineIcon.vue?vue&type=template&id=5f988e8a&"
import script from "./CloseOutlineIcon.vue?vue&type=script&lang=js&"
export * from "./CloseOutlineIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../mobile.zyp.one/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports